import api from "@/service/api";

const state = () => ({
    page: 1,
    creatorVideos: null,
    currentSlidePosition: null,
    slug: null,
    reachedTheEnd: false,
    hasMorePages: false,
    isPlaying: true,
    isMuted: true,
    progress: 0,
    currentTime: 0,
    maxDuration: 0,
    loopCount: 0,
})


const mutations = {
    reset(state) {
        state.progress = 0
        state.currentTime = 0
    },
    setPage(state, value) {
        state.page = value
    },
    setSlug(state, value) {
        state.slug = value
    },
    setCurrentTime(state, value) {
        if (state.currentTime > 1 && value < 1) {
            state.loopCount++
        }

        if (value > state.maxDuration) {
            state.maxDuration = value
        }

        state.currentTime = value
    },
    resetViewTracking(state) {
        state.currentTime = 0
        state.maxDuration = 0
        state.loopCount = 0
        state.progress = 0
    },
    setReachedTheEnd(state, value) {
        state.reachedTheEnd = value
    },
    setHasMorePages(state, value) {
        state.hasMorePages = value;
    },
    setProgress(state, value) {
        state.progress = value;
    },
    setIsPlaying(state, value) {
        state.isPlaying = value;
    },
    setIsMuted(state, value) {
        state.isMuted = value;
    },
    setCurrentSlidePosition(state, value) {
        state.currentSlidePosition = value
    },
    setCreatorVideos(state, value) {
        state.creatorVideos = value
    },
}

const actions = {
    async startOver({ commit, dispatch }) {
        commit('setSlug', null)
        commit('setReachedTheEnd', false)
        commit('setPage', 1)
        await dispatch('refresh')
    },
    async next({ state, commit, dispatch }) {
        // page 1 with slug is just that video
        // page 2 is essentially page 1 without slug
        if (state.slug) {
            commit('setSlug', null)
            await dispatch('refresh')
        } else {
            commit('setPage', state.page + 1)
            await dispatch('refresh')
        }
    },
    async prev({ state, commit, dispatch }) {
        if (state.page === 1) {
            return
        }

        commit('setPage', state.page - 1)
        await dispatch('refresh')
    },
    async refresh({ commit, state, dispatch }) {
        const response = await api.post("/creatorVideo/customerIndex", {
            page: state.page,
            slug: state.slug
        })

        const data = response?.data

        if (!data?.creatorVideos?.length && state.slug) {
            commit('setSlug', null)
            return dispatch('refresh')
        }

        commit('setCreatorVideos', data?.creatorVideos)
        commit('setHasMorePages', data?.hasMorePages)

        if (!data?.creatorVideos?.length) {
            commit('setReachedTheEnd', true)
        }
    },
    rate({ state }, { creatorVideoId, rating }) {
        api.post(`/creatorVideo/${creatorVideoId}/rating`, {
            rating,
            duration: parseInt(state.maxDuration) || null,
            count: state.loopCount || null,
        });
    },
    setCurrentSlidePosition({ commit, state }, currentSlidePosition) {
        commit('setCurrentSlidePosition', currentSlidePosition)

        if (state.creatorVideos?.[currentSlidePosition]) {
            commit('reset')

            commit(
                'videoPlayer/setCurrentCreatorVideo',
                state.creatorVideos?.[currentSlidePosition],
                { root: true }
            )
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
